import React from "react";
import PropTypes from "prop-types";
import "./button.css";

const Button = (props) => {
  const {
    children,
    onClick,
    type = "button",

    id,
    className = "",

    size = "md",
    variant = "primary",
    disabled = false,

    width,
    height,

    padding,
    margin,

    loading = false,

    style,
  } = props;

  return (
    <button
      id={id}
      type={type}
      className={`global-button global-button--${variant} global-button--${size} ${className}`}
      onClick={onClick}
      style={{ width, padding, margin, height, ...style }}
      disabled={disabled || loading}
    >
      {loading ? <span className="button-spinner"></span> : children}
    </button>
  );
};

export default Button;

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  id: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  variant: PropTypes.oneOf(["primary", "secondary", "danger"]),
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  loading: PropTypes.bool,

  style: PropTypes.object,
};
